// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

kendo-listview .no-data {
  padding: 5px;
  height: 100px;
  position: relative;
  top: 30px;
  text-align: left;
}
kendo-listview .message {
  width: 100%;
  min-width: 400px;
  padding-top: 5px;
  padding-bottom: 5px;
}
kendo-listview .docummessageent:hover {
  background-color: #efefef;
  cursor: pointer;
}
kendo-listview .message-title {
  margin: 0 4px;
}
kendo-listview .message.border-bottom {
  border-bottom: 1px solid lightgrey;
}

button {
  margin-top: 15px;
}

::ng-deep .k-listview-bordered > .k-listview-header {
  border-bottom-width: 0;
}

::ng-deep .k-listview-bordered > .k-listview-footer {
  border-width: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/components/communication-summary/lea-messages/lea-messages.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;;EAEE,gBAAA;EACA,eAAA;AACJ;;AAIE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,eAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,kCAAA;AALJ;;AASA;EACE,gBAAA;AANF;;AAUA;EACE,sBAAA;AAPF;;AAUA;EACE,eAAA;AAPF","sourcesContent":[".no-gutters {\r\n  margin-right: 0;\r\n  margin-left: 0;\r\n\r\n  > .col,\r\n  > [class*=\"col-\"] {\r\n    padding-right: 0;\r\n    padding-left: 0;\r\n  }\r\n}\r\n\r\nkendo-listview {\r\n  .no-data {\r\n    padding: 5px;\r\n    height: 100px;\r\n    position: relative;\r\n    top: 30px;\r\n    text-align: left;\r\n  }\r\n\r\n  .message {\r\n    width: 100%;\r\n    min-width: 400px;\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n  }\r\n\r\n  .docummessageent:hover {\r\n    background-color: #efefef;\r\n    cursor:pointer;\r\n  }\r\n\r\n  .message-title {\r\n    margin: 0 4px;\r\n  }\r\n\r\n  .message.border-bottom {\r\n    border-bottom: 1px solid lightgrey;\r\n  }\r\n}\r\n\r\nbutton {\r\n  margin-top: 15px;\r\n}\r\n\r\n\r\n::ng-deep .k-listview-bordered > .k-listview-header {\r\n  border-bottom-width: 0;\r\n}\r\n\r\n::ng-deep .k-listview-bordered > .k-listview-footer {\r\n  border-width: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
